<div class="l-wrapper">
  <app-header></app-header>
  <div class="l-main-about">
    <div class="l-main-about__img">
      <img
        src="./../../../../assets/img/company-main.png"
        alt=""
        class="c-pc"
      />
      <img
        src="./../../../../assets/img/company-sp-main.png"
        alt=""
        class="c-sp"
      />
    </div>
  </div>

  <app-management></app-management>

  <div class="l-main-about__table">
    <div translate>{{ "about.label.companyName" }}</div>
    <div translate>{{ "about.value.companyName" }}</div>

    <div translate>{{ "about.label.address" }}</div>
    <div translate>{{ "about.value.address" }}</div>

    <div translate>{{ "about.label.name" }}</div>
    <div translate>{{ "about.value.name" }}</div>

    <div translate>{{ "about.label.capital" }}</div>
    <div translate>{{ "about.value.capital" }}</div>

    <div translate>{{ "about.label.email" }}</div>
    <div translate>{{ "about.value.email" }}</div>

    <div translate>{{ "about.label.tel" }}</div>
    <div translate>{{ "about.value.tel" }}</div>

    <div translate>{{ "about.label.business" }}</div>
    <ul>
      <li translate>
        {{ "about.value.business.1" }}
      </li>
      <li translate>
        {{ "about.value.business.2" }}
      </li>
      <li translate>
        {{ "about.value.business.3" }}
      </li>
    </ul>
  </div>

  <div class="l-main-about__map">
    <iframe
      *ngIf="arrayPath[4] === 'jp'"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.10157129159!2d135.49949501523156!3d34.677385880440525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e71a2991e915%3A0x7f41fe0778651253!2z44CSNTQyLTAwODEg5aSn6Ziq5bqc5aSn6Ziq5biC5Lit5aSu5Yy65Y2X6Ii55aC077yT5LiB55uu77yX4oiS77yS77yXIGM!5e0!3m2!1sja!2sjp!4v1667118997787!5m2!1sja!2sjp"
      style="border: 0"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>

    <iframe
      *ngIf="arrayPath[4] !== 'jp'"
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13123.921146994142!2d135.498313!3d34.680447!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e7376842a721%3A0x7056c9891ce30b3f!2zTkxD5b-D5paO5qmL44OT44Or!5e0!3m2!1sen!2sjp!4v1675578525089!5m2!1sen!2sjp"
      style="border: 0"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
  <app-footer></app-footer>
</div>
